/*undefined*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.PartsCatalogueFilter = (function() {

    /**
     * Namespace PartsCatalogueFilter.
     * @exports PartsCatalogueFilter
     * @namespace
     */
    var PartsCatalogueFilter = {};

    PartsCatalogueFilter.PartsCatalogueFilterModel = (function() {

        /**
         * Properties of a PartsCatalogueFilterModel.
         * @memberof PartsCatalogueFilter
         * @interface IPartsCatalogueFilterModel
         * @property {string|null} [Make] PartsCatalogueFilterModel Make
         * @property {string|null} [sortColumn] PartsCatalogueFilterModel sortColumn
         * @property {string|null} [sortOrder] PartsCatalogueFilterModel sortOrder
         * @property {number|null} [pageIndex] PartsCatalogueFilterModel pageIndex
         * @property {number|null} [pageSize] PartsCatalogueFilterModel pageSize
         */

        /**
         * Constructs a new PartsCatalogueFilterModel.
         * @memberof PartsCatalogueFilter
         * @classdesc Represents a PartsCatalogueFilterModel.
         * @implements IPartsCatalogueFilterModel
         * @constructor
         * @param {PartsCatalogueFilter.IPartsCatalogueFilterModel=} [p] Properties to set
         */
        function PartsCatalogueFilterModel(p) {
            if (p)
                for (var ks = Object.keys(p), i = 0; i < ks.length; ++i)
                    if (p[ks[i]] != null)
                        this[ks[i]] = p[ks[i]];
        }

        /**
         * PartsCatalogueFilterModel Make.
         * @member {string|null|undefined} Make
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        PartsCatalogueFilterModel.prototype.Make = null;

        /**
         * PartsCatalogueFilterModel sortColumn.
         * @member {string|null|undefined} sortColumn
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        PartsCatalogueFilterModel.prototype.sortColumn = null;

        /**
         * PartsCatalogueFilterModel sortOrder.
         * @member {string|null|undefined} sortOrder
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        PartsCatalogueFilterModel.prototype.sortOrder = null;

        /**
         * PartsCatalogueFilterModel pageIndex.
         * @member {number|null|undefined} pageIndex
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        PartsCatalogueFilterModel.prototype.pageIndex = null;

        /**
         * PartsCatalogueFilterModel pageSize.
         * @member {number|null|undefined} pageSize
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        PartsCatalogueFilterModel.prototype.pageSize = null;

        // OneOf field names bound to virtual getters and setters
        var $oneOfFields;

        /**
         * PartsCatalogueFilterModel _Make.
         * @member {"Make"|undefined} _Make
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        Object.defineProperty(PartsCatalogueFilterModel.prototype, "_Make", {
            get: $util.oneOfGetter($oneOfFields = ["Make"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PartsCatalogueFilterModel _sortColumn.
         * @member {"sortColumn"|undefined} _sortColumn
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        Object.defineProperty(PartsCatalogueFilterModel.prototype, "_sortColumn", {
            get: $util.oneOfGetter($oneOfFields = ["sortColumn"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PartsCatalogueFilterModel _sortOrder.
         * @member {"sortOrder"|undefined} _sortOrder
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        Object.defineProperty(PartsCatalogueFilterModel.prototype, "_sortOrder", {
            get: $util.oneOfGetter($oneOfFields = ["sortOrder"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PartsCatalogueFilterModel _pageIndex.
         * @member {"pageIndex"|undefined} _pageIndex
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        Object.defineProperty(PartsCatalogueFilterModel.prototype, "_pageIndex", {
            get: $util.oneOfGetter($oneOfFields = ["pageIndex"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * PartsCatalogueFilterModel _pageSize.
         * @member {"pageSize"|undefined} _pageSize
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @instance
         */
        Object.defineProperty(PartsCatalogueFilterModel.prototype, "_pageSize", {
            get: $util.oneOfGetter($oneOfFields = ["pageSize"]),
            set: $util.oneOfSetter($oneOfFields)
        });

        /**
         * Encodes the specified PartsCatalogueFilterModel message. Does not implicitly {@link PartsCatalogueFilter.PartsCatalogueFilterModel.verify|verify} messages.
         * @function encode
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @static
         * @param {PartsCatalogueFilter.IPartsCatalogueFilterModel} m PartsCatalogueFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [w] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartsCatalogueFilterModel.encode = function encode(m, w) {
            if (!w)
                w = $Writer.create();
            if (m.Make != null && Object.hasOwnProperty.call(m, "Make"))
                w.uint32(10).string(m.Make);
            if (m.sortColumn != null && Object.hasOwnProperty.call(m, "sortColumn"))
                w.uint32(18).string(m.sortColumn);
            if (m.sortOrder != null && Object.hasOwnProperty.call(m, "sortOrder"))
                w.uint32(26).string(m.sortOrder);
            if (m.pageIndex != null && Object.hasOwnProperty.call(m, "pageIndex"))
                w.uint32(32).int32(m.pageIndex);
            if (m.pageSize != null && Object.hasOwnProperty.call(m, "pageSize"))
                w.uint32(40).int32(m.pageSize);
            return w;
        };

        /**
         * Encodes the specified PartsCatalogueFilterModel message, length delimited. Does not implicitly {@link PartsCatalogueFilter.PartsCatalogueFilterModel.verify|verify} messages.
         * @function encodeDelimited
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @static
         * @param {PartsCatalogueFilter.IPartsCatalogueFilterModel} message PartsCatalogueFilterModel message or plain object to encode
         * @param {$protobuf.Writer} [writer] Writer to encode to
         * @returns {$protobuf.Writer} Writer
         */
        PartsCatalogueFilterModel.encodeDelimited = function encodeDelimited(message, writer) {
            return this.encode(message, writer).ldelim();
        };

        /**
         * Decodes a PartsCatalogueFilterModel message from the specified reader or buffer.
         * @function decode
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} r Reader or buffer to decode from
         * @param {number} [l] Message length if known beforehand
         * @returns {PartsCatalogueFilter.PartsCatalogueFilterModel} PartsCatalogueFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartsCatalogueFilterModel.decode = function decode(r, l) {
            if (!(r instanceof $Reader))
                r = $Reader.create(r);
            var c = l === undefined ? r.len : r.pos + l, m = new $root.PartsCatalogueFilter.PartsCatalogueFilterModel();
            while (r.pos < c) {
                var t = r.uint32();
                switch (t >>> 3) {
                case 1:
                    m.Make = r.string();
                    break;
                case 2:
                    m.sortColumn = r.string();
                    break;
                case 3:
                    m.sortOrder = r.string();
                    break;
                case 4:
                    m.pageIndex = r.int32();
                    break;
                case 5:
                    m.pageSize = r.int32();
                    break;
                default:
                    r.skipType(t & 7);
                    break;
                }
            }
            return m;
        };

        /**
         * Decodes a PartsCatalogueFilterModel message from the specified reader or buffer, length delimited.
         * @function decodeDelimited
         * @memberof PartsCatalogueFilter.PartsCatalogueFilterModel
         * @static
         * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
         * @returns {PartsCatalogueFilter.PartsCatalogueFilterModel} PartsCatalogueFilterModel
         * @throws {Error} If the payload is not a reader or valid buffer
         * @throws {$protobuf.util.ProtocolError} If required fields are missing
         */
        PartsCatalogueFilterModel.decodeDelimited = function decodeDelimited(reader) {
            if (!(reader instanceof $Reader))
                reader = new $Reader(reader);
            return this.decode(reader, reader.uint32());
        };

        return PartsCatalogueFilterModel;
    })();

    return PartsCatalogueFilter;
})();

module.exports = $root;
